import React from 'react';

import { Slide } from '@material-ui/core';

import { LiveChatNotificationResponseNext } from '@alme/types/response/LiveChatNotificationResponse';

import { FocusComponentProps } from '../../../models/ComponentProps';

import { AlmeLiveChatResponseConfig } from './AlmeLiveChatResponseConfig';
import AlmeLiveChatBanner, { isValidLiveChatBannerResponse } from '../AlmeLiveChatBanner/AlmeLiveChatBanner';
import AlmeLiveChatOperatorResponse, { isValidLiveChatOperatorResponse } from './AlmeLiveChatOperatorResponse/AlmeLiveChatOperatorResponse';
import { isLiveChatResponse } from '@alme/api-ts/Utils';
import AlmeLiveChatUserResponse, { isValidLiveChatUserResponse } from './AlmeLiveChatUserResponse/AlmeLiveChatUserResponse';
import AlmeLiveChatSystemResponse, { isValidLiveChatSystemResponse } from './AlmeLiveChatSystemResponse/AlmeLiveChatSystemResponse';
import { DisplayLink } from '@alme/types/response/DisplayLink';
import { NavUrl } from '@alme/types/response/NavUrl';

interface AlmeLiveChatResponseProps {
    response: LiveChatNotificationResponseNext;
    isNewResponse?: boolean;
    isLastResponse: boolean;
    almeConfig: AlmeLiveChatResponseConfig;
    focusProps?: FocusComponentProps;
    responseId?: string | number;
    onScroll: () => void;
    onDisplayLinkClick: (link: DisplayLink | NavUrl) => void;
}

const AlmeLiveChatResponse: React.FC<AlmeLiveChatResponseProps> = (props: AlmeLiveChatResponseProps) => {

    const isChatResponse = isLiveChatResponse(props.response);
    const isOperatorResponse = isValidLiveChatOperatorResponse(props.response);
    const isUserResponse = isValidLiveChatUserResponse(props.response);
    const isSystemResponse = isValidLiveChatSystemResponse(props.response, props.isLastResponse);
    const isBannerResponse = isValidLiveChatBannerResponse(props.response);
    const isErrorResponse = !!props.response?.extensionData?.IsError;

    if (isErrorResponse || !isChatResponse || (!isOperatorResponse && !isUserResponse && !isSystemResponse && !isBannerResponse)) {
        return null;
    }

    /**
     * Note: Transient messages can be very verbose.
     * If scrolled to user can be pinned to the bottom of the history area.
     */

    const lcResponseComponent = (
        <div >
            <AlmeLiveChatUserResponse
                response={props.response}
                almeConfig={props.almeConfig.liveChatResponse}
                isLastResponse={props.isLastResponse}
                responseId={props.responseId}
                focusProps={props.focusProps}
            />
            <AlmeLiveChatOperatorResponse
                response={props.response}
                almeConfig={props.almeConfig.liveChatResponse}
                isLastResponse={props.isLastResponse}
                responseId={props.responseId}
                focusProps={props.focusProps}
                onDisplayLinkClick={props.onDisplayLinkClick}
            />
            <AlmeLiveChatSystemResponse
                response={props.response}
                almeConfig={props.almeConfig.liveChatResponse}
                isLastResponse={props.isLastResponse}
                responseId={props.responseId}
                focusProps={props.focusProps}
            />
            <AlmeLiveChatBanner response={props.response} responseId={props.responseId} almeConfig={props.almeConfig.liveChatResponse} onScroll={props.onScroll} />
        </div>
    );


    if (props.isNewResponse) {
        return (
            <Slide direction='up' in onEntered={props.onScroll}>
                {lcResponseComponent}
            </Slide>
        );
    } else {
        return lcResponseComponent;
    }
};

export default AlmeLiveChatResponse;
